import React from 'react';

import './scss/style.scss';

function Divider({ className }) {
  return (
    <hr className={className} />
  );
}

export default Divider;